import { DIAGNOSED_PROFILE_NAME } from '@constants';
class DiagnosedProfile {
    name;
    investmentAmount;
    experience;
    tolerance;
    horizon;
    liquidity;
    returnTarget;
    constructor(data) {
        this.name = data.name;
        this.investmentAmount = data.investmentAmount;
        this.experience = data.experience;
        this.tolerance = data.tolerance;
        this.horizon = data.horizon;
        this.liquidity = data.liquidity;
        this.returnTarget = data.returnTarget;
    }
    isSeed() {
        return Boolean(this.name === 'seed');
    }
    isExplorer() {
        return Boolean(this.name === 'explorer');
    }
    isPatrimonial() {
        return Boolean(this.name === 'patrimonial');
    }
    isStrategic() {
        return Boolean(this.name === 'strategic');
    }
    getLevelName() {
        return DIAGNOSED_PROFILE_NAME[this.name];
    }
}
export default DiagnosedProfile;
